<template>
    <paper class="requestFeeApply">
        <otp-panel
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :optionNum="optionNum"
            :currentPage="searchParams.pageNo"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @viewPic-btn="viewPicBtn"
            @reject-btn="rejectBtn"
            @editMile-btn="editMileBtn"
            searchId="requestFeeApply"
            pageID="requestFeeApply"
        >
            <div slot="table-module-btn">
                <report-export
                    #default="{ submit }"
                    reportCode="REPORT_OTP_NET_APPLY_FEE"
                >
                    <el-tooltip
                        effect="dark"
                        content="导出"
                        placement="bottom"
                        v-has="'10070003'"
                    >
                        <el-button
                            icon="icon-daochu"
                            size="mini"
                            @click="exportFile(submit)"
                        ></el-button>
                    </el-tooltip>
                </report-export>
            </div>
            <div slot="page-module-btn">
                <el-button
                    type="primary"
                    @click="confirmBtn(2)"
                    :disabled="loading"
                    v-has="'10070001'"
                    >通 过</el-button
                >
                <!-- <el-button
                    type="primary"
                    @click="confirmBtn(3)"
                    :disabled="loading"
                    v-has="'10070002'"
                >驳 回</el-button> -->
            </div>
        </otp-panel>
        <!-- 附件查看-photosBtn -->
        <attachment-view
            ref="attachmentView"
            v-if="netAttachmentShow"
            :rowData="rowData"
            :isReject="isReject"
            @close-dialog="closeDialog"
        ></attachment-view>
        <!-- 远程费用申请 -->
        <fund-request-dialog
            ref="fundRequestDialog"
            v-if="fundRequestDialog"
            @closeDialog="closeDialog"
        ></fund-request-dialog>
    </paper>
</template>
<script>
import AttachmentView from './components/AttachmentView';
import OtpPanel from '@/components/otpPanel';
import Paper from '@/components/core/paper/Paper';
import FundRequestDialog from './components/FundRequestDialog';
import api from '../../../api/requestFeeApply';
import { maxTwoMonths, maxOneMonths } from '../../../utils/common';
import config from './config';
import formatTime from '@/utils/common.js';
import ReportExport from '@/components/lots/reportExportPlugin';
import { mapGetters } from 'vuex';

export default {
    // 远程费用审核
    name: 'requestFeeApply',
    components: {
        OtpPanel,
        Paper,
        AttachmentView,
        ReportExport,
        FundRequestDialog
    },
    data() {
        return {
            config: config,
            loading: false,
            isReject: false,
            fundRequestDialog: false,
            isFirstSearch: true,
            netAttachmentShow: false,
            optionNum: '',
            rowData: {},
            totalData: [],
            pageTotal: 0,
            searchParams: {},
            pageParams: {
                orderBy: 'create_time',
                orderByType: 'desc',
                pageSize: 10,
                pageNo: 1
            },
            exportParams: {},
            selectedData: [],
            searchTotalTitle: config.searchTotalTitle
        };
    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    methods: {
        async getList() {
            this.loading = true;
            await api
                .getLists(this.searchParams)
                .then((res) => {
                    if (res && res.code === '0') {
                        if (
                            res.data.totalPage !== 0 &&
                            this.pageParams.pageNo > res.data.totalPage
                        ) {
                            this.pageParams.pageNo = this.searchParams.pageNo = res.data.totalPage;
                            this.getList();
                            return;
                        }
                        res.data.list.map((item) => {
                            if (+item.applystatus === 1) {
                                item.applystatusName = '待审核';
                            }
                            if (+item.applystatus === 2) {
                                item.applystatusName = '申请成功';
                            }
                            if (+item.applystatus === 3) {
                                item.applystatusName = '驳回';
                            }
                            item.actMile = item.actMile || 0;
                            item.planMile = item.planMile || 0;
                            item.hiddenEvent = [];
                            if (+item.actMile - +item.planMile < 5) {
                                item.hiddenEvent.push('viewPic');
                            }
                            if (+item.applystatus !== 1) {
                                item.hiddenEvent.push('reject');
                                item.hiddenEvent.push('editMile');
                            }
                            return item;
                        });
                        this.totalData = res.data.list || [];
                        this.pageTotal = res.data.totalCount;
                    } else {
                        this.totalData = [];
                    }
                })
                .catch(() => {});
            // 解决表格渲染问题
            await this.$nextTick(() => {
                this.$refs.tablePage.$refs.table.$refs.moduleTable.doLayout();
            });
            this.isFirstSearch = false;
            this.loading = false;
        },
        addData() {
            this.$refs.tablePage.$refs.table.addRow();
        },
        selectChange(data) {
            this.selectedData = data;
        },
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!maxOneMonths(this, this.exportParams.createStartTime, this.exportParams.createEndTime)) return;
            submit(this.exportParams);
            this.isFirstSearch = false;
        },
        viewPicBtn(rowData) {
            this.rowData = rowData;
            this.isReject = false;
            this.netAttachmentShow = true;
        },
        rejectBtn(rowData) {
            this.rowData = rowData;
            this.isReject = true;
            this.netAttachmentShow = true;
        },
        editMileBtn(rowData) {
            this.fundRequestDialog = true;
            this.$nextTick(() => {
                this.$refs.fundRequestDialog.show(rowData);
            });
        },
        checkTime(start, end) {
            const st = new Date(start).getTime();
            const et = new Date(end).getTime();
            return (et - st) <= 15 * 24 * 60 * 60 * 1000;
        },
        searchChange(data) {
            if (data.createTime && data.createTime.length > 0) {
                const startTime = formatTime.formatDateTime(
                    data.createTime[0]
                );
                const endTime = formatTime.formatDateTime(
                    data.createTime[1]
                );
                data.startTime = startTime.replace(/-/g, '/');
                data.endTime = endTime.replace(/-/g, '/');
                if (!this.checkTime(data.startTime, data.endTime)) {
                    this.$message.warning('时间跨度不能超过两周！');
                    return;
                }
            } else if (!data.createTime) {
                delete data.createStartTime;
                delete data.createEndTime;
            }
            if (!maxTwoMonths(this, data.createStartTime, data.createEndTime)) {
                return;
            }
            delete data.createTime;
            for (const key in data) {
                if (!data[key] && data[key] !== false && data[key] !== 0) {
                    delete data[key];
                }
            }
            this.pageParams.pageNo = 1;
            this.searchParams = { ...this.pageParams, ...data };
            this.exportParams = {
                ...this.searchParams,
                tenantCode: this.currentTenant.tenantCode
            };
            this.getList();
        },
        pageChange(data) {
            this.searchParams.pageNo = this.pageParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            this.searchParams.pageSize = this.pageParams.pageSize = data;
            this.getList();
        },
        // 批量通过或驳回
        async confirmBtn(type) {
            if (!this.selectedData.length) {
                this.$message({
                    type: 'warning',
                    message: '请选择需要审批的数据!'
                });
                return false;
            }
            let flag = true;
            this.selectedData.forEach((item) => {
                if (item.applystatus !== 1) {
                    flag = false;
                }
            });
            if (!flag) return this.$message.warning('仅可操作待审核信息');
            this.loading = true;
            const params = this.selectedData.map((item) => {
                return {
                    id: item.id,
                    orderNo: item.orderNo,
                    customerOrderNo: item.customerOrderNo,
                    applystatus: type,
                    townCode: item.townCode
                };
            });
            await api
                .saveItems(params)
                .then((res) => {
                    if (res && res.code === '0') {
                        this.$message.success('操作成功');
                        if (type === 2) {
                            this.selectedData.forEach((item) => {
                                api.sendJiFeiByNet({ orderNo: item.orderNo })
                                    .then((res) => {})
                                    .catch(() => {});
                            });
                        }
                        this.getList();
                    }
                })
                .catch(() => {});
            this.loading = false;
        },
        // 通用删除弹窗功能,使用v-if为减少页面组件同时加载数量，减轻用户设备压力
        closeDialog(dialogName, isRefresh) {
            this[dialogName] = false;
            if (isRefresh) this.getList();
        }
    }
};
</script>
<style lang="less">
    .requestFeeApply {
        .viewer-navbar {
            background-color: rgba(235, 232, 232, 0.5);
        }
    }
</style>
